// src/MessageList.tsx
import React from "react";
import { Message } from "../api/models";
import { MessageItem } from "./MessageItem";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  message_list: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
});

interface Props {
  messages: Message[];
  onFollowUpClick: (question: string) => void;
  onRateLimitError?: (error: any) => void;
}

export const MessageList: React.FC<Props> = ({ messages, onFollowUpClick, onRateLimitError }) => {
  const styles = useStyles();

  // Only render messages if there are any
  if (messages.length === 0) {
    return null;
  }

  // Find the index of the last assistant message
  const lastAssistantIndex = messages.map((msg, idx) => 
    msg.role === 'assistant' ? idx : -1
  ).filter(idx => idx !== -1).pop() ?? -1;

  return (
    <div className={styles.message_list}>
      {messages.map((msg, index) => {
        // For assistant messages, find the preceding user question
        let precedingQuestion = '';
        if (msg.role === 'assistant') {
          for (let i = index - 1; i >= 0; i--) {
            if (messages[i].role === 'user') {
              precedingQuestion = messages[i].englishText || '';
              break;
            }
          }
        }
        
        return (
          <MessageItem
            key={msg.uiMessageId}
            message={msg}
            onFollowUpClick={onFollowUpClick}
            isLatestAssistant={msg.role === 'assistant' && index === lastAssistantIndex}
            precedingQuestion={precedingQuestion}
            onRateLimitError={onRateLimitError}
          />
        );
      })}
    </div>
  );
};
